var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWordDocIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 8,
    fill: "#185ABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.946 22.349C13.993 22.705 14.024 23.015 14.039 23.28H14.093C14.114 23.029 14.156 22.726 14.218 22.37C14.279 22.015 14.339 21.715 14.398 21.47L16.922 11H20.186L22.798 21.314C22.928 21.824 23.038 22.471 23.124 23.259H23.168C23.2171 22.626 23.3079 21.997 23.44 21.376L25.53 11H28.5L24.844 26H21.372L18.881 16.062C18.7895 15.6912 18.7078 15.3181 18.636 14.943C18.545 14.483 18.489 14.149 18.467 13.939H18.424C18.394 14.183 18.339 14.546 18.255 15.027C18.171 15.508 18.105 15.863 18.054 16.094L15.714 26H12.19L8.5 11H11.524L13.8 21.492C13.851 21.707 13.899 21.994 13.946 22.349L18.5 13.647L13.946 22.349Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordDocIcon);
export default __webpack_public_path__ + "static/media/word-doc-icon.7ea01313.svg";
export { ForwardRef as ReactComponent };